export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  publishDate: string;
  imageUrl: string;
  imageSeq: string;
  tags: string[];
  isHot: boolean;
  isFeatured: boolean;
  readCount: number;
}

export interface CategoryInfo {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: CategoryInfo[] = [
  { name: '足球', slug: 'football', icon: 'ri-football-line', description: '全球足球赛事资讯，五大联赛、欧冠、世界杯等最新动态' },
  { name: '篮球', slug: 'basketball', icon: 'ri-basketball-line', description: 'NBA、CBA、欧洲篮球联赛等热门篮球赛事新闻' },
  { name: '综合格斗', slug: 'mma', icon: 'ri-boxing-line', description: 'UFC、拳击、综合格斗赛事最新资讯与深度分析' },
  { name: '网球', slug: 'tennis', icon: 'ri-base-station-line', description: '四大满贯、ATP、WTA赛事动态与球员专访' },
  { name: '电竞', slug: 'esports', icon: 'ri-gamepad-line', description: '英雄联盟、DOTA2、CS:GO等电竞赛事资讯' },
  { name: '赛车', slug: 'racing', icon: 'ri-steering-line', description: 'F1、MotoGP、WRC等顶级赛车赛事报道' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '欧冠决赛前瞻：皇马vs曼城，两大豪门巅峰对决谁能问鼎欧洲之巅',
    excerpt: '2026年欧冠决赛即将在伊斯坦布尔打响，皇家马德里与曼彻斯特城将展开一场火星撞地球的较量。皇马凭借丰富的决赛经验，曼城则依靠瓜迪奥拉的战术体系，这场对决注定载入史册。',
    content: `<p>2026年欧洲冠军联赛决赛即将在土耳其伊斯坦布尔的阿塔图尔克奥林匹克体育场隆重上演。西甲豪门皇家马德里将与英超劲旅曼彻斯特城展开一场巅峰对决，争夺欧洲俱乐部足球的最高荣誉。</p>
<p>皇家马德里作为欧冠历史上最成功的俱乐部，拥有15座欧冠奖杯的辉煌战绩。本赛季在主帅安切洛蒂的带领下，皇马展现出强大的韧性和战术执行力。维尼修斯和姆巴佩组成的锋线组合火力全开，贝林厄姆在中场的统治力也令人印象深刻。</p>
<p>曼城方面，瓜迪奥拉的球队以传控足球闻名于世。哈兰德本赛季状态火热，各项赛事已打入42球。德布劳内的创造力加上罗德里的中场屏障，使得曼城在攻防两端都保持着极高的水准。</p>
<p>双方在历史上共交手12次，皇马取得5胜3平4负的微弱优势。最近一次交锋是在2025年的欧冠半决赛，当时皇马以总比分4-3险胜晋级。</p>
<p>赛前发布会上，安切洛蒂表示："曼城是一支非常强大的球队，但我们有信心在决赛中发挥出最好的水平。欧冠决赛对于皇马来说有着特殊的意义。"瓜迪奥拉则回应道："我们尊重皇马的成就，但在伊斯坦布尔，曼城将全力以赴争取胜利。"</p>
<p>这场比赛不仅是两支顶级球队的较量，更是两种足球理念的碰撞。皇马代表着欧冠的传统与荣耀，曼城则象征着现代足球的战术革新。无论结果如何，这场比赛都将成为欧冠历史上的经典之战。</p>`,
    category: '足球',
    categorySlug: 'football',
    author: '王涛',
    publishDate: '2026-08-07',
    imageUrl: 'https://readdy.ai/api/search-image?query=Champions%20League%20final%20atmosphere%20in%20a%20grand%20stadium%20at%20night%2C%20players%20in%20white%20and%20sky%20blue%20jerseys%20competing%20intensely%20on%20the%20pitch%2C%20dramatic%20stadium%20lighting%2C%20professional%20sports%20photography%20style%2C%20epic%20atmosphere%20with%20fans%20in%20background%2C%20warm%20golden%20and%20green%20tones%2C%20cinematic%20composition&width=1200&height=675&seq=article-football-1&orientation=landscape',
    imageSeq: 'article-football-1',
    tags: ['欧冠', '皇马', '曼城', '决赛', '足球'],
    isHot: true,
    isFeatured: true,
    readCount: 125680,
  },
  {
    id: 'article-2',
    title: 'NBA夏季联赛：中国新星王浩然惊艳表现，狂砍35分引全美关注',
    excerpt: '年仅19岁的中国篮球新星王浩然在NBA夏季联赛中表现惊艳，单场轰下35分8篮板5助攻的全面数据，成为本届夏季联赛最受关注的亚洲球员。',
    content: `<p>2026年NBA夏季联赛在拉斯维加斯如火如荼地进行中。来自中国的19岁新星王浩然在对阵洛杉矶湖人队的比赛中，全场出战36分钟，21投14中，三分球9投5中，轰下35分8篮板5助攻2抢断的全面数据，帮助球队以108-95取得胜利。</p>
<p>王浩然身高2米08，司职小前锋，去年在CBA联赛中场均贡献22.5分7.3篮板4.1助攻，被誉为中国男篮未来十年的核心球员。今年他宣布参加NBA选秀，并在第二轮第38顺位被选中。</p>
<p>本场比赛，王浩然展现出了全面的进攻手段。他不仅能在三分线外精准投射，还多次利用灵活的脚步突破内线完成得分。第三节比赛中，他单节砍下16分，带领球队打出一波18-2的攻击波，彻底改变了比赛走势。</p>
<p>赛后，ESPN评论员史蒂芬·A·史密斯评价道："这个年轻人有着令人难以置信的天赋，他的投篮手感和运动能力让我想起了年轻时的麦迪。如果他能继续保持这样的进步速度，他将在NBA拥有一段非常光明的职业生涯。"</p>
<p>王浩然在赛后接受采访时表示："能够在这个级别的比赛中展现自己的实力，我感到非常兴奋。但我清楚这只是开始，我还有很多需要学习和提高的地方。感谢教练和队友们的信任，我会继续努力。"</p>
<p>随着王浩然在夏季联赛中的出色表现，他在新赛季获得稳定出场时间的可能性大大增加。中国球迷也对他的NBA之旅充满期待。</p>`,
    category: '篮球',
    categorySlug: 'basketball',
    author: '李明',
    publishDate: '2026-08-06',
    imageUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20basketball%20player%20dunking%20dramatically%20in%20NBA%20summer%20league%20game%2C%20wearing%20red%20jersey%2C%20intense%20action%20shot%20with%20crowd%20cheering%20in%20background%2C%20bright%20arena%20lights%2C%20professional%20sports%20photography%2C%20dynamic%20composition%20with%20motion%20blur&width=1200&height=675&seq=article-basketball-1&orientation=landscape',
    imageSeq: 'article-basketball-1',
    tags: ['NBA', '王浩然', '中国篮球', '夏季联赛'],
    isHot: true,
    isFeatured: false,
    readCount: 98230,
  },
  {
    id: 'article-3',
    title: 'UFC 310：张伟丽成功卫冕草量级冠军，五回合激战尽显王者风范',
    excerpt: '在UFC 310的主赛中，中国综合格斗女王张伟丽经过五个回合的激烈对抗，以一致判定击败挑战者，成功卫冕女子草量级冠军金腰带。',
    content: `<p>北京时间8月5日，UFC 310在美国拉斯维加斯T-Mobile竞技场隆重举行。中国综合格斗选手张伟丽在头条主赛中对阵巴西挑战者，经过五个回合的激烈对抗，最终以一致判定（49-46, 48-47, 49-46）获胜，成功卫冕UFC女子草量级冠军金腰带。</p>
<p>比赛一开始，张伟丽就展现出了极强的侵略性，利用精准的拳法组合和灵活的移动控制了比赛节奏。第一回合中段，她的一记后手直拳准确命中对手面部，险些终结比赛。</p>
<p>挑战者在第二和第三回合加强了摔跤进攻，两次成功将张伟丽带入地面。但张伟丽展现出了出色的地面防守能力，不仅成功化解了对手的降服尝试，还在第三回合末段完成了一次精彩的翻转，获得了上位优势。</p>
<p>第四和第五回合，张伟丽再次掌握了站立打击的主动权。她的腿法攻击对对手造成了明显的伤害，多次低扫让挑战者的移动速度明显下降。最终，三位裁判一致判定张伟丽获胜。</p>
<p>赛后，张伟丽在八角笼中激动地表示："每一次卫冕都比上一次更加艰难，但这就是冠军的考验。感谢我的团队，感谢所有支持我的中国拳迷，这枚金腰带属于你们！"</p>
<p>本场胜利使张伟丽的职业战绩提升至26胜3负，她也成为UFC历史上卫冕次数最多的亚洲选手。UFC总裁白大拿在赛后新闻发布会上盛赞张伟丽是"草量级历史上最伟大的冠军之一"。</p>`,
    category: '综合格斗',
    categorySlug: 'mma',
    author: '刘强',
    publishDate: '2026-08-05',
    imageUrl: 'https://readdy.ai/api/search-image?query=Female%20MMA%20fighter%20in%20octagon%20raising%20championship%20belt%20victoriously%2C%20UFC%20arena%20with%20dramatic%20spotlight%20overhead%2C%20intense%20celebration%20moment%2C%20professional%20fight%20sports%20photography%2C%20warm%20arena%20lighting%2C%20heroic%20composition&width=1200&height=675&seq=article-mma-1&orientation=landscape',
    imageSeq: 'article-mma-1',
    tags: ['UFC', '张伟丽', '综合格斗', '草量级', '冠军卫冕'],
    isHot: true,
    isFeatured: false,
    readCount: 156420,
  },
  {
    id: 'article-4',
    title: '英超新赛季前瞻：阿森纳补强阵容剑指冠军，利物浦重建之路挑战重重',
    excerpt: '2026-2027赛季英超联赛即将拉开帷幕，各支球队在转会市场上动作频频。阿森纳豪掷两亿英镑补强阵容，志在打破曼城的冠军垄断。',
    content: `<p>随着2026-2027赛季英超联赛的临近，各支球队的备战工作已进入最后冲刺阶段。经过一个夏天的转会运作，新赛季的英超格局可能发生重大变化。</p>
<p>阿森纳在阿尔特塔的带领下，上赛季以微弱差距屈居亚军。今夏，枪手在转会市场上展现出极大的野心，先后签下了世界级中锋和顶级防守中场，总投入超过两亿英镑。球队阵容深度得到显著提升，被博彩公司列为仅次于曼城的夺冠第二大热门。</p>
<p>曼城虽然在转会市场上相对平静，但瓜迪奥拉的球队依然保持着强大的竞争力。哈兰德、德布劳内和罗德里的核心框架稳定，加上青训体系中涌现出的新星，蓝月亮仍是冠军的最有力争夺者。</p>
<p>利物浦在克洛普离开后进入重建期。新帅在战术理念上带来了新的变化，但球队在防线上仍存在隐患。萨拉赫的去留问题也悬而未决，红军新赛季前景充满不确定性。</p>
<p>切尔西在波切蒂诺的调教下逐渐找到节奏，年轻球员的成长令人欣喜。热刺和纽卡斯尔也在积极补强，力争欧冠资格。升班马方面，利兹联和莱斯特城重返英超后将面临严峻的保级考验。</p>
<p>2026-2027赛季英超将于8月12日正式开赛，揭幕战将由卫冕冠军曼城主场迎战升班马利兹联。新赛季的英超赛场注定精彩纷呈。</p>`,
    category: '足球',
    categorySlug: 'football',
    author: '王涛',
    publishDate: '2026-08-04',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premier%20League%20soccer%20stadium%20with%20players%20in%20red%20and%20white%20jerseys%20competing%20on%20green%20pitch%2C%20dramatic%20match%20action%20with%20ball%20in%20air%2C%20packed%20stadium%20crowd%2C%20professional%20sports%20photography%2C%20bright%20daylight%2C%20wide%20angle%20composition&width=1200&height=675&seq=article-football-2&orientation=landscape',
    imageSeq: 'article-football-2',
    tags: ['英超', '阿森纳', '曼城', '利物浦', '新赛季'],
    isHot: false,
    isFeatured: false,
    readCount: 78450,
  },
  {
    id: 'article-5',
    title: 'CBA休赛期重磅交易：周琦转会上海男篮，创CBA历史最高转会费纪录',
    excerpt: '中国篮坛传来重磅消息，国家队核心中锋周琦正式转会上海大鲨鱼男篮，转会费高达8000万人民币，刷新CBA联赛历史纪录。',
    content: `<p>北京时间8月3日，CBA联赛官方宣布，中国男篮核心中锋周琦正式从新疆广汇男篮转会至上海大鲨鱼男篮。据了解，这笔交易的转会费高达8000万人民币，刷新了CBA联赛的历史最高转会费纪录。</p>
<p>周琦今年28岁，身高2米17，是中国男篮当之无愧的内线核心。上赛季他在新疆队场均贡献21.3分11.7篮板2.8盖帽，投篮命中率达到62.5%。他的加盟将极大提升上海男篮的内线实力。</p>
<p>上海男篮总经理在官方声明中表示："我们非常高兴能够迎来周琦这样世界级的球员。他的加盟是上海男篮冲击CBA总冠军的重要一步。我们相信在周琦的带领下，上海男篮将在新赛季展现出强大的竞争力。"</p>
<p>据悉，周琦与上海男篮签订了一份为期三年的顶薪合同，年薪达到CBA规定的最高限额。此外，合同中还包含了多项激励条款，包括夺冠奖金和MVP奖金等。</p>
<p>这笔交易的达成也引发了CBA转会市场的连锁反应。多支球队开始积极调整阵容，为新赛季的竞争做准备。业内人士普遍认为，周琦加盟上海男篮将改变CBA联赛的格局，上海队一跃成为新赛季的夺冠热门。</p>
<p>周琦本人也在社交媒体上发文表示："感谢新疆队多年的培养和球迷们的支持。新的征程即将开始，我将在上海全力以赴，为冠军而战！"</p>`,
    category: '篮球',
    categorySlug: 'basketball',
    author: '李明',
    publishDate: '2026-08-03',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tall%20Chinese%20basketball%20center%20in%20red%20jersey%20making%20a%20powerful%20dunk%20during%20professional%20game%2C%20indoor%20basketball%20arena%20with%20bright%20lights%2C%20dynamic%20action%20photography%2C%20intense%20sports%20moment%2C%20clean%20background&width=1200&height=675&seq=article-basketball-2&orientation=landscape',
    imageSeq: 'article-basketball-2',
    tags: ['CBA', '周琦', '上海男篮', '转会'],
    isHot: false,
    isFeatured: false,
    readCount: 89200,
  },
  {
    id: 'article-6',
    title: 'ATP上海大师赛：阿尔卡拉斯逆转夺冠，中国小将商竣程闯入八强创历史',
    excerpt: '2026年ATP上海大师赛落下帷幕，世界第一阿尔卡拉斯在决赛中上演惊天逆转。中国19岁小将商竣程历史性闯入八强，创造个人最佳战绩。',
    content: `<p>2026年ATP1000上海大师赛在旗忠网球中心圆满落幕。世界排名第一的西班牙名将卡洛斯·阿尔卡拉斯在决赛中以3-6、7-5、6-3逆转击败对手，时隔两年再次捧起上海大师赛冠军奖杯。</p>
<p>决赛过程跌宕起伏。首盘比赛中，阿尔卡拉斯似乎还没有找到最佳状态，被对手抓住机会率先破发。但西班牙天才在第二盘展现出了世界第一的实力，在关键时刻完成回破，将比赛拖入决胜盘。</p>
<p>决胜盘中，阿尔卡拉斯的状态完全被激发出来。他的正手进攻犀利无比，防守覆盖范围令人惊叹。最终他在第九局完成致命破发，以6-3锁定胜局。</p>
<p>本届赛事的另一大亮点是中国19岁小将商竣程的表现。他从资格赛打起，一路过关斩将，先后击败了两位世界排名前20的选手，历史性闯入八强。虽然在四分之一决赛中不敌最终冠军阿尔卡拉斯，但他的表现赢得了全场观众的掌声。</p>
<p>商竣程赛后表示："这是我职业生涯中最美好的一周。能够在家乡观众面前与世界第一交手，是一次无比宝贵的经历。我会继续努力，争取在未来取得更好的成绩。"</p>
<p>随着商竣程等年轻选手的崛起，中国男子网球的未来充满希望。本届上海大师赛也创下了超过15万人次的观众纪录。</p>`,
    category: '网球',
    categorySlug: 'tennis',
    author: '张伟',
    publishDate: '2026-08-02',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20player%20hitting%20powerful%20forehand%20shot%20on%20blue%20hard%20court%20in%20large%20stadium%2C%20dramatic%20action%20moment%20with%20ball%20in%20frame%2C%20bright%20sunlight%2C%20sports%20photography%20style%2C%20dynamic%20composition&width=1200&height=675&seq=article-tennis-1&orientation=landscape',
    imageSeq: 'article-tennis-1',
    tags: ['网球', 'ATP', '阿尔卡拉斯', '商竣程', '上海大师赛'],
    isHot: false,
    isFeatured: false,
    readCount: 67430,
  },
  {
    id: 'article-7',
    title: '英雄联盟S16全球总决赛：LPL赛区四支战队全部晋级八强，创造历史最佳战绩',
    excerpt: '2026英雄联盟全球总决赛小组赛阶段全部结束，来自中国LPL赛区的四支战队全部以小组第一身份晋级八强淘汰赛，创造了LPL赛区在S赛历史上的最佳小组赛战绩。',
    content: `<p>2026年英雄联盟S16全球总决赛小组赛在韩国首尔全部结束。来自中国LPL赛区的四支参赛战队——JDG、BLG、TES和WBG全部以各自小组第一名的身份晋级八强淘汰赛。这是LPL赛区历史上首次实现四支战队同时晋级淘汰赛的壮举。</p>
<p>JDG作为LPL夏季赛冠军，在A组展现出统治级别的实力，以6胜0负的完美战绩出线。中单选手的表现尤为亮眼，场均KDA高达8.5，被官方评为小组赛MVP。</p>
<p>BLG在B组的征程相对艰难，前两场比赛一度以0胜2负开局，但随后调整状态连赢四场，最终以4胜2负的战绩获得小组第一。下路组合的默契配合是BLG翻盘的关键。</p>
<p>TES在C组同样表现强势，5胜1负的战绩让他们轻松锁定淘汰赛席位。上单选手的纳尔和贾克斯在小组赛中表现出色，多次在团战中完成关键操作。</p>
<p>WBG在D组的出线之路最为曲折。最后一轮比赛中，他们必须在三队同分的情况下通过加赛决出晋级名额。最终WBG在加赛中击败欧洲劲旅，惊险获得八强席位。</p>
<p>八强淘汰赛将于8月10日在釜山会展中心打响。LPL四支战队的对手分别为LCK和LEC赛区的代表队伍。中国电竞迷对LPL战队在淘汰赛中的表现充满期待。</p>`,
    category: '电竞',
    categorySlug: 'esports',
    author: '陈宇',
    publishDate: '2026-08-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Grand%20esports%20arena%20filled%20with%20passionate%20fans%20and%20giant%20LED%20screens%20displaying%20League%20of%20Legends%20gameplay%2C%20dramatic%20stage%20lighting%20with%20colorful%20effects%2C%20professional%20esports%20event%20photography%2C%20epic%20atmosphere&width=1200&height=675&seq=article-esports-1&orientation=landscape',
    imageSeq: 'article-esports-1',
    tags: ['英雄联盟', 'LPL', 'S16', '电竞', 'LOL'],
    isHot: false,
    isFeatured: false,
    readCount: 103560,
  },
  {
    id: 'article-8',
    title: 'F1摩纳哥大奖赛：维斯塔潘强势夺冠，中国车手周冠宇主场首秀获第九名',
    excerpt: '2026年F1摩纳哥大奖赛精彩落幕，红牛车手维斯塔潘以统治级表现夺冠。中国车手周冠宇在主场观众面前表现出色，获得第九名为车队带回积分。',
    content: `<p>2026年F1世界一级方程式锦标赛摩纳哥大奖赛在蒙特卡洛赛道圆满结束。红牛车队的世界冠军马克斯·维斯塔潘以领先第二名超过20秒的巨大优势夺得冠军，这是他本赛季的第七个分站冠军。</p>
<p>维斯塔潘从杆位出发，整场比赛没有给对手任何机会。他在摩纳哥狭窄的街道赛道上的驾驶堪称完美，每一圈都精准地控制着赛车的极限。赛后他表示："在摩纳哥获胜总是特别的，这条赛道对车手的要求非常高，我很享受今天比赛中的每一圈。"</p>
<p>中国车手周冠宇在本站比赛中迎来了个人在摩纳哥的首秀。他从第13位发车，通过出色的轮胎管理和稳定的驾驶，最终以第九名的成绩完赛，为车队带回了宝贵的积分。</p>
<p>周冠宇赛后激动地表示："摩纳哥是我最喜欢的赛道之一，能在这里完成比赛并获得积分，我感到非常开心。感谢车队的策略安排，我们在比赛中做出了正确的轮胎选择。看到现场有很多中国车迷为我加油，这给了我额外的动力。"</p>
<p>本场比赛后，维斯塔潘以285分继续领跑车手积分榜，红牛车队在车队积分榜上也大幅领先。F1下一站将移师加拿大蒙特利尔。</p>`,
    category: '赛车',
    categorySlug: 'racing',
    author: '赵刚',
    publishDate: '2026-07-31',
    imageUrl: 'https://readdy.ai/api/search-image?query=Formula%201%20race%20car%20speeding%20through%20Monaco%20street%20circuit%20with%20harbor%20and%20yachts%20in%20background%2C%20bright%20sunny%20day%2C%20motion%20blur%20effect%20showing%20speed%2C%20professional%20motorsport%20photography%2C%20dramatic%20racing%20atmosphere&width=1200&height=675&seq=article-racing-1&orientation=landscape',
    imageSeq: 'article-racing-1',
    tags: ['F1', '维斯塔潘', '周冠宇', '摩纳哥大奖赛'],
    isHot: false,
    isFeatured: false,
    readCount: 56120,
  },
  {
    id: 'article-9',
    title: '世界杯预选赛亚洲区：中国男足2-1逆转泰国，武磊两球助球队锁定胜局',
    excerpt: '2026年世界杯亚洲区预选赛关键战役中，中国男足在上半场落后一球的情况下，凭借武磊下半场的梅开二度，2-1逆转战胜泰国队，继续保有晋级希望。',
    content: `<p>北京时间7月30日，2026年世界杯亚洲区预选赛18强赛继续进行。中国男足在主场沈阳奥体中心迎战泰国队，在全场四万多名球迷的助威声中，中国队在上半场落后的不利局面下完成逆转，以2-1击败对手。</p>
<p>比赛第23分钟，泰国队利用一次快速反击机会率先打破僵局，中国队门将王大雷虽然奋力扑救但仍未能阻止皮球入网。落后的中国队并没有慌乱，在随后的比赛中逐渐掌控了场上节奏。</p>
<p>下半场易边再战，中国队主教练果断调整战术，加强了边路进攻。第58分钟，武磊在禁区内接到队友的精准传中，头球破门将比分扳平。这粒进球彻底点燃了全场观众的热情。</p>
<p>第76分钟，武磊再次展现了他的杀手本能。在一次角球进攻中，他在混战中机敏地将球捅入网窝，完成了梅开二度，帮助中国队2-1反超比分。</p>
<p>比赛最后阶段，泰国队全力反扑但未能改写比分。最终中国队以2-1取得胜利，继续在小组中保持晋级世界杯的希望。武磊也凭借本场比赛的两粒进球，将个人国家队进球数提升至40球。</p>
<p>武磊赛后表示："这是一场艰难的比赛，但全队展现出了顽强的斗志。只要还有一丝希望，我们就会拼到最后一刻。感谢现场球迷的支持，这场胜利属于所有中国球迷。"</p>`,
    category: '足球',
    categorySlug: 'football',
    author: '王涛',
    publishDate: '2026-07-30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20national%20football%20team%20players%20in%20red%20jerseys%20celebrating%20goal%20on%20pitch%2C%20packed%20stadium%20with%20waving%20flags%2C%20dramatic%20night%20match%20atmosphere%2C%20professional%20sports%20photography%2C%20emotional%20celebration%20moment&width=1200&height=675&seq=article-football-3&orientation=landscape',
    imageSeq: 'article-football-3',
    tags: ['世界杯预选赛', '中国男足', '武磊', '泰国'],
    isHot: false,
    isFeatured: false,
    readCount: 198450,
  },
  {
    id: 'article-10',
    title: 'NBA自由市场：勒布朗·詹姆斯续约湖人，职业生涯总薪资突破6亿美元',
    excerpt: 'NBA传奇球星勒布朗·詹姆斯与洛杉矶湖人队达成两年1.2亿美元的续约协议，这将使他的职业生涯总薪资突破6亿美元大关，创下NBA历史新纪录。',
    content: `<p>NBA洛杉矶湖人队官方宣布，球队与勒布朗·詹姆斯达成了一份为期两年、总价值1.2亿美元的续约合同。这份合同将使詹姆斯至少在湖人队效力至2028-2029赛季结束，届时他将年满44岁。</p>
<p>这份续约合同的达成，意味着詹姆斯的职业生涯总薪资将正式突破6亿美元大关（约合人民币43亿元），成为NBA历史上第一位达到这一里程碑的球员。加上场外代言收入，詹姆斯的职业生涯总收入预计已超过15亿美元。</p>
<p>詹姆斯在上赛季依然保持着极高的竞技水准，场均贡献25.7分、7.3篮板和8.3助攻，投篮命中率达到52.8%。湖人在他的带领下成功打进了西部决赛。</p>
<p>湖人队总经理在声明中表示："勒布朗不仅是湖人队的核心，也是整个NBA历史上最伟大的球员之一。他的职业精神、领导力和对胜利的渴望，每天都激励着整支球队。我们非常高兴他能继续身披紫金战袍。"</p>
<p>詹姆斯也在社交媒体上发文表示："洛杉矶是我的家，湖人国度是我的家人。我还有很多目标要去实现，还有很多比赛要去赢。让我们一起继续这段旅程！#湖人秀"</p>
<p>随着詹姆斯的续约，湖人队将继续围绕他打造争冠阵容。据悉，球队正在积极运作其他交易，力争在新赛季重返总决赛舞台。</p>`,
    category: '篮球',
    categorySlug: 'basketball',
    author: '李明',
    publishDate: '2026-07-29',
    imageUrl: 'https://readdy.ai/api/search-image?query=Lebron%20James%20in%20purple%20and%20gold%20Lakers%20jersey%20dribbling%20basketball%20during%20NBA%20game%2C%20intense%20focused%20expression%2C%20bright%20arena%20lights%2C%20professional%20basketball%20photography%2C%20dramatic%20atmosphere%2C%20action%20shot&width=1200&height=675&seq=article-basketball-3&orientation=landscape',
    imageSeq: 'article-basketball-3',
    tags: ['NBA', '詹姆斯', '湖人', '续约'],
    isHot: false,
    isFeatured: false,
    readCount: 134680,
  },
  {
    id: 'article-11',
    title: 'ONE冠军赛：中国格斗新星李凯文首回合KO对手，剑指雏量级冠军',
    excerpt: 'ONE冠军赛新加坡站，中国综合格斗选手李凯文在雏量级比赛中首回合KO泰国名将，将自己的职业战绩提升至12胜2负，正式进入冠军挑战者行列。',
    content: `<p>ONE冠军赛新加坡站在新加坡室内体育馆精彩上演。中国综合格斗选手李凯文在雏量级主赛中对阵泰国名将，仅用2分18秒就以一记精准的膝击KO对手获胜。</p>
<p>比赛开始后，李凯文迅速进入状态，利用灵活的步伐和精准的拳法不断给对手施加压力。在第一回合进行到2分10秒时，他在一次近距离缠斗中突然起膝，准确命中对手下巴，对手应声倒地，裁判随即终止比赛。</p>
<p>这场胜利使李凯文的职业战绩提升至12胜2负，其中8次KO/TKO获胜。赛后，ONE冠军赛官方宣布李凯文将进入雏量级冠军挑战者排名前三位，有望在今年内获得冠军挑战权。</p>
<p>李凯文赛后在接受采访时表示："我来到ONE冠军赛就是为了成为冠军。今天的表现只是一个开始，我准备好了挑战任何人。感谢团队的支持，感谢中国拳迷的关注。"</p>
<p>现年26岁的李凯文来自湖南长沙，练习散打出身，后转型综合格斗。他以其出色的站立打击能力和爆发力在亚洲格斗界崭露头角。近年来在ONE冠军赛的出色表现，让他成为中国综合格斗新生代的代表人物。</p>
<p>ONE冠军赛CEO对李凯文的评价是："他是一个非常令人兴奋的选手，每次比赛都能给观众带来惊喜。中国综合格斗正在快速发展，李凯文是其中的佼佼者。"</p>`,
    category: '综合格斗',
    categorySlug: 'mma',
    author: '刘强',
    publishDate: '2026-07-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20MMA%20fighter%20in%20ONE%20Championship%20cage%20delivering%20powerful%20knee%20strike%20to%20opponent%2C%20dramatic%20fight%20moment%2C%20arena%20with%20bright%20lights%2C%20professional%20combat%20sports%20photography%2C%20intense%20action%20shot&width=1200&height=675&seq=article-mma-2&orientation=landscape',
    imageSeq: 'article-mma-2',
    tags: ['ONE冠军赛', '李凯文', '综合格斗', 'KO'],
    isHot: false,
    isFeatured: false,
    readCount: 89340,
  },
  {
    id: 'article-12',
    title: '温网女单决赛：郑钦文三盘苦战惜败，获得亚军创造中国网球新历史',
    excerpt: '2026年温布尔登网球锦标赛女单决赛中，中国选手郑钦文经过三盘苦战，最终以1-2惜败世界第一，获得亚军。这是中国选手在温网女单赛场的最佳战绩。',
    content: `<p>2026年温布尔登网球锦标赛女单决赛在中央球场精彩上演。中国选手、赛会7号种子郑钦文在决赛中对阵世界排名第一的卫冕冠军。经过2小时48分钟的激烈对抗，郑钦文以6-4、3-6、4-6不敌对手，获得亚军。</p>
<p>首盘比赛，郑钦文发挥出色，利用强劲的正手进攻和精准的底线控制，在第七局完成关键破发，以6-4先下一城。她的表现让全场观众为之惊叹。</p>
<p>第二盘开始，对手调整了战术策略，加强了上网频率和变线进攻。郑钦文在第二局遭遇破发后虽然奋力追赶但未能挽回劣势，以3-6丢掉第二盘。</p>
<p>决胜盘中，双方展开了激烈的拉锯战。郑钦文在体能下降的情况下依然展现出了顽强的斗志，多次在险境中挽救破发点。但最终在第九局被对手抓住机会完成破发，以4-6惜败。</p>
<p>尽管未能夺冠，郑钦文已经创造了中国选手在温网女单赛场的最佳战绩。她也是继李娜之后，第二位闯入大满贯单打决赛的中国选手。</p>
<p>郑钦文在颁奖仪式上表示："这是我职业生涯中最特别的一周。虽然没能赢得冠军，但我为自己的表现感到骄傲。感谢所有支持我的人，我会继续努力，争取下次站上最高领奖台。"</p>`,
    category: '网球',
    categorySlug: 'tennis',
    author: '张伟',
    publishDate: '2026-07-27',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20tennis%20player%20on%20Wimbledon%20grass%20court%20in%20white%20tennis%20outfit%2C%20hitting%20backhand%20shot%2C%20classic%20English%20tennis%20atmosphere%2C%20green%20grass%20court%2C%20elegant%20sports%20photography%2C%20bright%20summer%20daylight&width=1200&height=675&seq=article-tennis-2&orientation=landscape',
    imageSeq: 'article-tennis-2',
    tags: ['温网', '郑钦文', '网球', '大满贯', '决赛'],
    isHot: false,
    isFeatured: false,
    readCount: 145890,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter(
    (article) => article.categorySlug === categorySlug
  );
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((article) => article.id === id);
};

export const getHotArticles = (limit: number = 6): Article[] => {
  return articles.filter((a) => a.isHot).slice(0, limit);
};

export const getFeaturedArticles = (limit: number = 4): Article[] => {
  return articles.filter((a) => a.isFeatured).slice(0, limit);
};

export const getLatestArticles = (limit: number = 10): Article[] => {
  return [...articles]
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
    .slice(0, limit);
};

export const getRelatedArticles = (articleId: string, limit: number = 4): Article[] => {
  const current = getArticleById(articleId);
  if (!current) return [];
  return articles
    .filter((a) => a.id !== articleId && a.categorySlug === current.categorySlug)
    .slice(0, limit);
};